module.exports = {
  credentialActivated: 'Credential activated successfully',
  credentialDeactivated: 'Credential deactivated successfully',
  credentialCreated: 'Credential created successfully',
  credentialUpdated: 'Credential updated successfully',
  cronActivated: 'Cron activated successfully',
  cronDeactivated: 'Cron deactivated successfully',
  cronCreated: 'Cron created successfully',
  cronUpdated: 'Cron updated successfully',
  restActivated: 'Rest activated successfully',
  restDeactivated: 'Rest deactivated successfully',
  restCreated: 'Rest created successfully',
  restUpdated: 'Rest updated successfully',
  processActivated: 'Process activated successfully',
  processDeactivated: 'Process deactivated successfully',
  processCreated: 'Process created successfully',
  processUpdated: 'Process updated successfully',
  copiedClipboard: 'Copied to clipboard',
  userActivated: 'User activated successfully',
  userDeactivated: 'User deactivated successfully',
  userCreated: 'User created successfully',
  userUpdated: 'User updated successfully',
  roleCreated: 'Role created successfully',
  roleUpdated: 'Role updated successfully',
  test: 'Test Successful',
  templateCreated: 'Template created successfully',
  templateUpdated: 'Template updated successfully',
  translationCreated: 'Translation created successfully',
  translationUpdated: 'Translation updated successfully',
  translationDeleted: 'Translation deleted successfully',
  resendPassword: 'Password reset instructions sent successfully',
  settingActivated: 'Setting activated successfully',
  settingDeactivated: 'Setting deactivated successfully',
  settingCreated: 'Setting created successfully',
  settingUpdated: 'Setting updated successfully',
  stepCopy: 'Step copied successfully',
  cronExecute: 'Cron execute successful with Event ID:',
  restUrlCheckIsExist: 'Check successful, URL exists on trigger ID:',
  restUrlCheckNoExist: 'Check successful, URL doesn\'t exists',
  moduleCreated: 'Module created successfully',
  moduleUpdated: 'Module updated successfully',
  moduleExport: 'Module exported successfully',
  moduleImport: 'Module imported successfully',
  moduleValidate: 'Module validated successfully',
  validationCreated: 'Validation rule created successfully',
  validationUpdated: 'Validation rule updated successfully',
  apiKeyGeneration: 'ApiKey generated successfully',
  moduleUploaded: 'Module uploaded successfully',
  moduleDownloaded: 'Module downloaded successfully',
  moduleInstalled: 'Module installed successfully',
  pluginActivated: 'Plugin activated successfully',
  pluginDeactivated: 'Plugin deactivated successfully',
  pluginCreated: 'Plugin created successfully',
  pluginUpdated: 'Plugin updated successfully',
  pluginImport: 'Plugin imported successfully',
}
